import { consoleLogger } from '../logging/consoleLogger';

export const getClientConfig = (host) => {
  const { CALLS_CONFIG, IDCONNECT_CONFIG } =
    window.Utiq?.data?.clientConfig || {};

  /* If the config is already present in the API layer, we do not want to override it for custom setups and UAT */
  if (
    typeof CALLS_CONFIG === 'object' &&
    Object.keys(CALLS_CONFIG).length !== 0 &&
    typeof IDCONNECT_CONFIG === 'object' &&
    Object.keys(IDCONNECT_CONFIG).length !== 0
  ) {
    consoleLogger.logInfo(
      'Client configuration detected in data layer. Loading the detected configuration...',
    );
    consoleLogger.logDebug(
      `Client calls configuration from data layer: ${JSON.stringify(
        CALLS_CONFIG,
      )}`,
    );
    consoleLogger.logDebug(
      `Client fc configuration from data layer: ${JSON.stringify(
        IDCONNECT_CONFIG,
      )}`,
    );
  } else {
    const IDCONNECT_CONFIG = {
      IDCONNECT_API_HOST: `${host}/op/idconnect`,
      IDCONNECT_DATA_STORAGE: 'utiqPass',
      IDCONNECT_DOMAIN_STORAGE_TRANSLATION: {
        'mobile-token.telekom.de': 'tmi.telekom.de',
      },
      IDCONNECT_STORAGE_TYPE: 'localStorage',
      IDCONNECT_TYPE: 'utiq',
      IDCONNECT_ALLOWED_USE_CASES: [
        'token',
        'stub',
        'utiqCrossDomain',
        'mspProxy',
        'saml',
      ],
      IDCONNECT_ALLOW_TOKEN_DATA_CALL: true,
      IDCONNECT_ALLOW_TOKEN_DATA_CALL_COUNTER: 1,
    };
    const CALLS_CONFIG = {
      intervalId: null,
      conditions: {
        timeConditions: {
          oncePerSession: false,
          oncePerTimeInterval: 600000,
        },
        oncePerPage: false,
        urls: null,
      },
      callsToMake: {
        idConnect: true,
      },
      callsPerPage: {
        idConnect: false,
      },
    };

    window.Utiq ||= {};
    window.Utiq.data ||= {};
    window.Utiq.data.clientConfig = {
      CALLS_CONFIG,
      IDCONNECT_CONFIG,
    };
    window.IDCONNECT_CONFIG = IDCONNECT_CONFIG;

    consoleLogger.logDebug(
      `Loaded new client configuration: ${JSON.stringify(IDCONNECT_CONFIG)}`,
    );
  }
};
